import { render, staticRenderFns } from "./DemandeAttachmentsForm.vue?vue&type=template&id=5ebb7d56&scoped=true"
import script from "./DemandeAttachmentsForm.vue?vue&type=script&lang=js"
export * from "./DemandeAttachmentsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebb7d56",
  null
  
)

export default component.exports